import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Validable } from '../common-behaviors/validate.mixin';
import { Fee } from './fee.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { NumberFilter, StringFilter } from 'src/app/filter/filter';

const FeeHistoryMixinBase = Validable(AtomResource);

@Resource({
  type: 'feehistories',
})
export class FeeHistory extends AtomResource {
  @Attribute({
    convert: (value: number | undefined) => {
      return typeof value === 'number' ? (value * 100).toFixed(2) : undefined;
    },
    revert: (value: number | undefined) =>
      typeof value === 'number' ? value / 100 : undefined,
  })
  rate?: number;
  @Attribute()
  amount?: number;
  @Attribute() validity?: string;
  @Attribute({ key: 'validity_tz' }) validityTz?: string;

  @Relationship() fee?: Fee;
}
export class FeeHistoryConfig implements ResourceConfig {
  hosted?: string | undefined = 'fees';
  wizard = {
    tabs: [
      {
        title: 'Fee History',
        formGroup: 'fee',
        list: [
          {
            type: 'validity',
            title: 'Validity',
            formControl: 'validity',
          },
          {
            type: 'number',
            title: 'Percent',
            formControl: 'rate',
            // required: true,
          },
          {
            type: 'number',
            title: 'Amount',
            formControl: 'amount',
            // required: true,
          },
        ],
      },
    ],
  };
  resource = FeeHistory;
  resourceKey?: string | undefined = 'feehistories';
  resourceKeySingle?: string | undefined = 'feehistory';
  resourceName?: string | undefined = 'feehistories';
  filters = [new NumberFilter('id', 'ID', true)];
}
